window.toggleEst = function (est: Element) {
	let currActive = document.querySelector(
		'.inspections-table .establishment.active'
	)

	if (est != currActive) {
		currActive?.classList.remove('active')

		est.setAttribute(
			'style',
			`--height: ${est.querySelector('.details')?.scrollHeight}px;`
		)
		est.classList.toggle('active')
	}
}

// Handles active establishment for both mobile and desktop
const establishments = document.querySelectorAll(
	'.inspections-table .establishment'
)
window.addEventListener('resize', e => {
	establishments.forEach(est => {
		est.setAttribute(
			'style',
			`--height: ${est.querySelector('.details')?.scrollHeight}px;`
		)
	})
})

// Handles sortby
const sortby = document.querySelector('.sortby-wrapper')
sortby?.addEventListener('click', e => {
	sortby.classList.toggle('active')
})
window.addEventListener('click', e => {
	if (!e.target.closest('.sortby-wrapper')) {
		sortby?.classList.remove('active')
	}
})

// Handles form
const form = document.querySelector('.actions form')
form?.addEventListener('submit', e => {
	e.preventDefault()
})
